import {getQuanmaiApi,postQuanmaiApi} from './proxy'

export default class {
  /*
    获取用户任务数据接口
   */
  GetUserMission(data){
    return getQuanmaiApi('/Users/getUserMission',data)
  }
   /*
    用户做任务接口
   */
  DoMission(data){
    return postQuanmaiApi('/Users/doMission',data)
  }
  /*
  用户签到接口
  */
 SignDay(data){
  return postQuanmaiApi('/Users/signDay',data)
 }
 /*
 获取用户签到数据接口
 */
GetUserSign(data){
  return getQuanmaiApi('/Users/getUserSign',data)
 }
 /*
 获取用户积分记录接口
 */
GetUserScoreRecord(data){
  return getQuanmaiApi('/Users/getUserScoreRecord',data)
 }
}


// WEBPACK FOOTER //
// ./src/service/jifenService.js